import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EnvironmentService } from './environment.service';
import { PaginationRequest } from './models/pagination/pagination.request.model';
import { RequestHelper } from '@shared/helpers/request.helper';

@Injectable({ providedIn: 'root' })
export class TicketApiService {
    constructor(
        private httpClient: HttpClient,
        private environmentService: EnvironmentService
    ) {}

    private get url(): string {
        return `${this.environmentService.getCurrentApiUrl()}/tickets`;
    }

    searchTickets(req: PaginationRequest, body: any): Observable<any> {
        const options = RequestHelper.createRequestOption(req);
        return this.httpClient.post<any>(`${this.url}/search`, body, { params: options });
    }

    getTicketById(id: string): Observable<any> {
        return this.httpClient.get<any>(`${this.url}/${id}`);
    }

    createTicket(ticket: any): Observable<any> {
        return this.httpClient.post<any>(this.url, ticket);
    }

    updateTicket(ticket: any): Observable<any> {
        return this.httpClient.put<any>(this.url, ticket);
    }

    deleteTicket(id: string): Observable<any> {
        return this.httpClient.delete<any>(`${this.url}/${id}`);
    }
}

